// extracted by mini-css-extract-plugin
module.exports = {"post":"postMeta-module--post--3LHSC","link":"postMeta-module--link--1oOkI"};